



































































































import { Component, Ref, Vue } from 'vue-property-decorator'
import BotaoDeDrawer from '@/components/ui/BotaoDeDrawer.vue'
import { VendaModule } from '@/store/vuex/venda/VendaStore'
import { Loja, TurnoDeVenda } from '@/models'
import Confirmacao from '@/components/ui/Confirmacao.vue'
import AlertModule from '@/store/vuex/aplicacao/AlertModule'
import SeletorDeLojas from '@/components/loja/SeletorDeLojas.vue'
import IconesDaToolbarPadroes from '@/components/layout/IconesDaToolbarPadroes.vue'
import { FindLojaUseCase } from '@/usecases/loja/FindLojaUseCase'
import type { VendaServiceAdapter } from '@/usecases'
import { Inject } from 'inversify-props'

@Component({
	components: {
		BotaoDeDrawer,
		Confirmacao,
		IconesDaToolbarPadroes,
		SeletorDeLojas,
	},
})
export default class ToolbarDeVendas extends Vue  {
	@Ref() botaoDeDevolucao?: { $el: HTMLButtonElement }
	@Ref() botaoDeFechamentoDeCaixa?: { $el: HTMLButtonElement }
	@Ref() botaoDeMovimentarCaixa?: { $el: HTMLButtonElement }
	@Ref() confirmacaoDeDescartarVenda!: Confirmacao
	@Ref() botaoDeRefresh?: { $el: HTMLButtonElement }

	@Inject('VendaServiceAdapter')
	private vendaService!: VendaServiceAdapter

	carregandoRefresh = false
	findLojaUseCase = new FindLojaUseCase()

	get loja() {
		return VendaModule.lojaDaVenda
	}

	set loja(loja: Loja | null) {
		VendaModule.setLojaDaVenda(loja)
	}

	get turnoDeVenda() {
		return VendaModule.turnoDeVenda
	}

	set turnoDeVenda(turno: TurnoDeVenda | null) {
		VendaModule.setTurnoDeVenda(turno)
	}

	async mostrarDevolucao() {
		const resultado = await VendaModule.autenticarAcao({ regra: 'pode-fazer-devolucao' })
		if (!resultado?.autenticado) return
		await this.irParaDialogoDeDevolucao()
	}

	async irParaDialogoDeDevolucao() {
		const loja = VendaModule.lojaDaVenda
		if (!loja)
			return AlertModule.setError('Nenhuma loja selecionada para vender')
		if(!loja.seriesFiscais.some(serie => serie.tipo === "Devolução"))
			return AlertModule.setError('Loja não possui série fiscal de devolução')
		if (VendaModule.temVendaEmAndamento && !await this.confirmacaoDeDescartarVenda.mostrar()) return
		this.$router
			.push({
				name: this.$route.name as string,
				query: { devolucao: 'true' },
			})
			.catch()
	}

	async mostrarFechamento() {
		if(await VendaModule.moverParaMovimentacoesCasoNaoTenhaAnexo()) return
		if (VendaModule.temVendaEmAndamento && !await this.confirmacaoDeDescartarVenda.mostrar()) return
		this.$router
			.push({
				name: this.$route.name as string,
				query: { closing: null },
			})
			.catch()
	}
	mostrarMovimentacao() {
		this.$router
			.push({
				name: this.$route.name as string,
				query: { ['cash-handling']: null },
			})
			.catch()
	}

	created() {
		document.addEventListener('keydown', this.atalhoDeDevolucao)
		document.addEventListener('keydown', this.atalhoDeFecharCaixa)
		document.addEventListener('keydown', this.atalhoDeMovimentarCaixa)
	}
	destroyed() {
		document.removeEventListener('keydown', this.atalhoDeDevolucao)
		document.removeEventListener('keydown', this.atalhoDeFecharCaixa)
		document.removeEventListener('keydown', this.atalhoDeMovimentarCaixa)
	}
	atalhoDeDevolucao(event: KeyboardEvent) {
		if (!event.altKey || event.key.toLowerCase() !== 't') return
		if (!this.botaoDeDevolucao) return
		event.preventDefault()
		this.botaoDeDevolucao.$el.click()
	}
	atalhoDeFecharCaixa(event: KeyboardEvent) {
		if (!event.altKey || event.key.toLowerCase() !== 'a') return
		if (!this.botaoDeFechamentoDeCaixa) return
		event.preventDefault()
		this.botaoDeFechamentoDeCaixa.$el.click()
	}
	atalhoDeMovimentarCaixa(event: KeyboardEvent) {
		if (!event.altKey || event.key.toLowerCase() !== 'm') return
		if (!this.botaoDeMovimentarCaixa) return
		event.preventDefault()
		this.botaoDeMovimentarCaixa.$el.click()
	}
	get temVendaComPagamentos() {
		return VendaModule.temVendaComPagamentos
	}

	get pdvSomenteDemonstracaoEConsignado(): boolean {
		return VendaModule.turnoDeVenda?.pontoDeVenda?.somenteDemonstracaoEConsignado || false
	}

	get liberaRefreshNoCaixa(): boolean {
		if (!this.loja || !this.loja.configuracaoDaLoja) return false
		return this.loja.configuracaoDaLoja.liberaRefreshDeLojaNoCaixa
	}

	async recarregarLoja() {
		if (this.carregandoRefresh) return

		const lojaAtual = VendaModule.lojaDaVenda
		if (!lojaAtual?.id) {
			return AlertModule.setError('Nenhuma loja selecionada para atualizar')
		}

		if (VendaModule.temVendaEmAndamento) {
			const confirmou = await this.confirmacaoDeDescartarVenda.mostrar()
			if (!confirmou) return

			const podeContinuar = await this.validarPagamentos()
			if (!podeContinuar) return

			await this.iniciarNovaVenda()
		}

		try {
			
			this.carregandoRefresh = true
			const lojaDaVenda = await this.findLojaUseCase.findLojaById(lojaAtual.id)
			await VendaModule.setLojaDaVenda(lojaDaVenda)

			const novosTipos = lojaDaVenda.tiposDePagamento
			const pdvIdAtual = this.turnoDeVenda?.pontoDeVenda.id
			const pdvAtualizado = lojaDaVenda.pdvs?.find((p: any) => p.id === pdvIdAtual)
			patchTiposDePagamentoTurno(novosTipos, pdvAtualizado)

			AlertModule.setSuccess('Configurações da loja atualizadas')
		} catch (e) {
			AlertModule.setError('Não foi possível atualizar as configurações da loja')
		} finally {
			this.carregandoRefresh = false
		}
	}

	async iniciarNovaVenda() {
		const identificador = await this.vendaService.gerarIdentificadorDeVenda(
			this.turnoDeVenda?.pontoDeVenda.id || '',
		)

		await VendaModule.iniciarNovaVenda({ identificador, novaVendaReaberta: false })
	}

	
	async validarPagamentos(): Promise<boolean> {
		const pagamentosPorTef = VendaModule.vendaAtual?.pagamentos?.filter(
    pagamento => pagamento.tipoDePagamento.formaDePagamento === 'TEF Crédito' ||
      pagamento.tipoDePagamento.formaDePagamento === 'TEF Débito' ||
      pagamento.tipoDePagamento.formaDePagamento === 'TEF Pix',
  ) ?? []

		if (pagamentosPorTef.length > 0) {
			AlertModule.setError(
				'Existe pagamento(s) por TEF autorizado(s) na venda atual. Não é possível continuar.',
			)
			return false
		}

		return true
	}
}

const TURNO_DE_VENDA_STORAGE = 'TURNO_DE_VENDA_STORAGE'

export function patchTiposDePagamentoTurno(novosTipos: any[], pdvAtualizado: any) {
	if (VendaModule.turnoDeVenda) {
		VendaModule.setTurnoDeVenda({
			...VendaModule.turnoDeVenda,
			tiposDePagamento: novosTipos,
			pontoDeVenda: pdvAtualizado,
		})
		return
	}

	const raw = localStorage.getItem(TURNO_DE_VENDA_STORAGE)
	if (!raw || raw === 'null') return
	const turno = JSON.parse(raw)
	turno.tiposDePagamento = novosTipos
	turno.pontoDeVenda = pdvAtualizado
	localStorage.setItem(TURNO_DE_VENDA_STORAGE, JSON.stringify(turno))
}
